import type { CompanyResponse } from '@shared/schemas';

import api from '@/shared/api/api-client';

import { toServerPage } from '../domain/pagination';
import type { CompanyQueryGateway } from './company-query';

/**
 * Real implementation of the shared company-read query, parameterised by endpoint.
 * The admin Companies and client Institutionals lists share the same request/
 * response shape on `GET /companies` (the backend scopes by role), so each slice
 * binds this factory to its path. `getRaw` preserves the `{ data, pagination }`
 * envelope so we can read the grand total. Paging is 1:1 with the original
 * `useInfiniteApi`.
 */
export function makeCompanyQueryHttp(path: string): CompanyQueryGateway {
  return {
    fetchCompanies: async ({ page, pageSize }) => {
      const res = await api.getRaw<CompanyResponse[]>(
        `${path}?page=${toServerPage(page)}&limit=${pageSize}`,
      );
      const rows = res.data ?? [];
      return { rows, total: res.pagination?.total ?? rows.length };
    },
  };
}
